import React, { useRef, useState } from "react";

// import upload from "@safecv/images/upload.png";
import upload from "../../assets/images/upload.png";

import "./SupportingDocument.css";

const fileType = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
];
const ext = "PDF / DOC / DOCX";

const SupportingDocument = (props) => {
  const { setUploadedAddDocs, fromModal } = props;

  const fileInputRef = useRef();
  const [fileData, setFileData] = useState([]);
  const [invalidError, setInvalidError] = useState(false);

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  const onFilesAdded = (e) => {
    if (e.target.files.length > 0) {
      validateFiles(e.target.files);
    }
  };

  const validateFiles = (uploadedFiles) => {
    setInvalidError(false);
    let files = [...fileData];
    for (let i = 0; i < uploadedFiles.length; i++) {
      if (fileType.includes(uploadedFiles[i].type)) {
        files.push(uploadedFiles[i]);
      } else {
        setInvalidError(true);
      }
    }
    setFileData(files);
    setUploadedAddDocs(files);
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDragLeave = (e) => {
    e.preventDefault();
  };

  const onDrop = (e) => {
    e.preventDefault();
    validateFiles(e.dataTransfer.files);
  };

  const handleDeleteFile = (index) => {
    let files = [...fileData];
    files.splice(index, 1);
    setFileData(files);
    setUploadedAddDocs(files);
  };

  return (
    <div className="doc-upload-container">
      {!fromModal && (
        <div className="upload-additional-document">
          Upload Additional Documents
        </div>
      )}
      <div
        onDrop={onDrop}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        className={`upload-container ${
          invalidError ? "upload-error-container" : ""
        }`}
      >
        <input
          multiple
          type="file"
          accept={fileType}
          ref={fileInputRef}
          className="file-input"
          onChange={onFilesAdded}
        />
        <div className="upload-text-container">
          <img alt="upload" src={upload} />
          <div className="upload-text"> Drag and drop files here </div>
          <div className="upload-text"> Or </div>
          <div
            className="supp-doc-upload-button"
            onClick={() => openFileDialog()}
          >
            Choose Files
          </div>
        </div>
        {invalidError && (
          <div className="upload-error">
            Files having incorrect format will not be processed, please Upload{" "}
            {ext} files only.
          </div>
        )}
      </div>
      <div className={`${fromModal ? "file-list-wrapper" : ""}`}>
        {fileData.map((file, index) => (
          <div className="file-list-container" key={index}>
            <div className="file-name"> {file.name} </div>
            <div
              title="delete file"
              className="file-delete"
              onClick={() => handleDeleteFile(index)}
            >
              X
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportingDocument;
